<template>
  <b-nav-item-dropdown no-caret>
    <template slot="button-content">
      <span class="btn-text">Trade Marketing</span>
    </template>
    <b-dropdown-item
      v-for="module in filteredUserModules"
      :key="module.id"
      :disabled="!module.is_active"
      @click="$router.push({name: module.component_name})"
    >
      {{ module.description }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>
import dropdownTradeMarketingComposition from './compositions/DropdownTradeMarketing'

export default {
  name: 'HeaderDropdownTradeMarketing',
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  setup (props, context) {
    const { filteredUserModules } = dropdownTradeMarketingComposition(props, context)
    return {
      filteredUserModules
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/nav_bar/HeaderDropdownTradeMarketing.vue